import React, {
    createContext,
    useContext,
    useState,
    ReactNode,
    useEffect,
    useCallback,
  } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, Heading, SimpleGrid, Text, useToast, GridItem } from "@chakra-ui/react";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "react-i18next";
import Card from "../components/Card/Card";
import CardBody from "../components/Card/CardBody";
import CardHeader from "../components/Card/CardHeader";


export const Authorize  =  () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useToast();
  const { currentUser, getToken } = useAuth();


  useEffect(() => {
    if (!currentUser) {
      navigate("/login");
    }
  }, [currentUser, navigate]);

  const handleAuthorization = async () => {

    const token = await getToken();


    try {
      const params = new URLSearchParams(location.search);
      const amazonState = params.get("amazon_state");
      const amazonCallbackUri = params.get("amazon_callback_uri");
      const sellingPartnerId = params.get("selling_partner_id");

      if (!amazonState || !sellingPartnerId) {
        throw new Error("Missing required parameters");
      }

      const response = await fetch("/.netlify/functions/generateAuthorizationUrl", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({
          amazonState,
          amazonCallbackUri,
          sellingPartnerId
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to generate authorization URL");
      }

      const { authorizationUrl } = await response.json();
      window.location.href = authorizationUrl;
    } catch (error) {
      console.error("Error generating authorization URL:", error);
      toast({
        title: t("authorizeError"),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="50vh"
      w='50%'
      m='auto'
      p={8}
    >
      <Card>
    
        <CardHeader>
        <Heading as="h1" size="xl" mb={4}>
            {t("authorizeAmazon")}
        </Heading>  
        </CardHeader>  
        <CardBody>
        <SimpleGrid width='100%' columns={{ base: 1, md: 1 }} spacing='20px'>
         <GridItem>
         <Text fontSize="lg" mb={8}>
          {t("authorizeAmazonDescription")}
        </Text>
         </GridItem>
       <GridItem>
        <Button colorScheme="blue" size="lg" onClick={handleAuthorization}>
          {t("authorizeAmazonButton")}
          </Button></GridItem>
        </SimpleGrid>
        </CardBody>
      </Card>
    </Box>
  );
};

export default Authorize;
